import { render, staticRenderFns } from "./ConfirmMovementDialog.vue?vue&type=template&id=f5f4de44&scoped=true&"
import script from "./ConfirmMovementDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmMovementDialog.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmMovementDialog.vue?vue&type=style&index=0&id=f5f4de44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f4de44",
  null
  
)

export default component.exports